import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Header } from 'components/common/header/Header';
import { InvitationInfoForm } from 'components/invitation/InvitationInfoForm';
import './InvitationInfo.css';

export const InvitationInfo = () => {
    const navigate = useNavigate();
    const { inviteCode } = useParams();

    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');

    const isNextEnabled = name.trim().length > 0 && phone.length >= 10;

    const handlePhoneChange = (value: string) => {
        const numbers = value.replace(/[^0-9]/g, '');

        if (numbers.length <= 3) {
            setPhone(numbers);
        } else if (numbers.length <= 7) {
            setPhone(`${numbers.slice(0, 3)}-${numbers.slice(3)}`);
        } else if (numbers.length <= 11) {
            setPhone(`${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`);
        }
    };

    const handleNext = () => {
        if (isNextEnabled) {
            navigate(`/invitation/location/${inviteCode}`);
        }
    };

    return (
        <div className="invitation-info-wrapper">
            <Header title="참여 정보 입력" isSubPage />

            <div className="invitation-info-content">
                <InvitationInfoForm
                    name={name}
                    phone={phone}
                    onNameChange={setName}
                    onPhoneChange={handlePhoneChange}
                    onNext={handleNext}
                    isNextEnabled={isNextEnabled}
                />
            </div>
        </div>
    );
};
